import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import questions from '../data/reformationQuiz.json';
import { createQuiz, QUIZ_LENGTH } from '../utils/faithQuiz';
import FaithQuizResult from '../components/FaithQuizResult';
import './ReformationQuiz.css';

const categories = { reformation: 'カルバン・ルター', theology: '神学の基礎', safety: 'カルトの特徴' };

export default function ReformationQuiz() {
  const [round, setRound] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [index, setIndex] = useState(0);
  const [review, setReview] = useState(false);
  const heading = useRef(null);
  const finished = round && index === round.length;
  const question = round && round[index];
  const selected = answers[index];
  const answered = selected !== undefined;
  const score = round ? round.filter((q, i) => answers[i] === q.answer).length : 0;

  useEffect(() => { if (round) heading.current?.focus(); }, [round, index]);

  function start(items = questions, count = QUIZ_LENGTH, isReview = false) {
    setRound(createQuiz(items, count));
    setAnswers([]);
    setIndex(0);
    setReview(isReview);
  }

  return <main className="reformation-quiz" lang="ja">
    <Helmet><title>信仰クイズ | ASMR教会</title></Helmet>
    <Link to="/">← 聖書のトップへ</Link>
    <header>
      <h1>信仰クイズ</h1>
    </header>
    {!round ? <section className="reformation-quiz__card">
      <h2>ランダム{QUIZ_LENGTH}問</h2>
      <p>カルバン・ルターの著作、キリスト教神学の基礎、カルトの特徴。全{questions.length}問から出題します。</p>
      <button className="reformation-quiz__primary" onClick={() => start()}>クイズを始める</button>
      <p className="reformation-quiz__note">回答後に解説と出典を表示します。問題と選択肢の順番は毎回変わります。</p>
    </section> : finished ? <section className="reformation-quiz__card">
      <h2 tabIndex={-1} ref={heading}>結果：{round.length}問中{score}問正解</h2>
      <FaithQuizResult score={score} total={round.length} review={review} />
      <p>{score === round.length ? '全問正解です！ 出典を読み、理解を深めてみましょう。' : '解説を読みながら、もう一度考えてみましょう。'}</p>
      <ol className="reformation-quiz__review">{round.map((q, i) => <li key={q.id}>
        <strong>{answers[i] === q.answer ? '○ 正解' : '× 不正解'}：{q.question}</strong>
        <p>正解：{q.choices[q.answer]}</p><p>{q.explanation}</p>
        <a href={q.source.url} target="_blank" rel="noreferrer">{q.source.label}（出典）</a>
      </li>)}</ol>
      {score < round.length && <button className="reformation-quiz__primary" onClick={() => start(round.filter((q, i) => answers[i] !== q.answer), round.length, true)}>間違えた問題に再挑戦</button>}
      <button onClick={() => start()}>新しい10問に挑戦</button>
      <button onClick={() => { setRound(null); setAnswers([]); setIndex(0); }}>最初に戻る</button>
    </section> : <section className="reformation-quiz__card">
      <p>{index + 1} / {round.length}問 · {categories[question.category]}</p>
      <progress value={index} max={round.length} aria-label="回答を終えた問題数" />
      <h2 ref={heading} tabIndex={-1}>{question.question}</h2>
      <div className="reformation-quiz__choices">{question.choices.map((choice, i) => <button
        key={choice} disabled={answered}
        className={answered && i === question.answer ? 'is-correct' : answered && i === selected ? 'is-incorrect' : ''}
        onClick={() => { if (!answered) setAnswers(previous => [...previous, i]); }}>
        <span>{'ABCD'[i]}.</span> {choice}{answered && i === question.answer ? '（正解）' : answered && i === selected ? '（あなたの回答）' : ''}
      </button>)}</div>
      <div aria-live="polite" aria-atomic="true">{answered && <div className="reformation-quiz__feedback">
        <h3>{selected === question.answer ? '正解！' : '惜しい！'} 正解は{'ABCD'[question.answer]}</h3>
        <p>{question.explanation}</p>
        <p>出典：<a href={question.source.url} target="_blank" rel="noreferrer">{question.source.label}</a></p>
        {question.source.excerpt && <details key={question.id}><summary>根拠の原文を読む</summary>
          <blockquote lang={question.source.language || 'en'}>{question.source.excerpt}</blockquote>
          {question.source.startLine && <p className="reformation-quiz__note">収録テキスト {question.source.startLine}–{question.source.endLine}行</p>}
        </details>}
        <button className="reformation-quiz__primary" onClick={() => setIndex(index + 1)}>{index + 1 === round.length ? '結果を見る' : '次の問題へ'}</button>
      </div>}</div>
    </section>}
  </main>;
}
